export default {
    NONE: 0,
    SINGLE: 1,
    JOINT: 2,
    0: 'None',
    1: 'Single',
    2: 'Joint'
};